import {useEffect, useContext, useState} from 'react';

import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar,
  IonGrid,IonCol,IonRow,IonItem,IonLabel,IonInput,IonButton,
  useIonToast, useIonLoading} from '@ionic/react';
import { useParams } from 'react-router';
import ExploreContainer from '../components/ExploreContainer';


import {AppContext} from '../global';
  
import {updatePassword} from '../hooks/AdminHttp';

import styles from '../common/styles.module.css';

import {useHistory, useLocation} from 'react-router';


interface Json {[key:string]:any};


const UpdatePassword: React.FC<{
  email:string,
  role:string,
  onCloseClicked:()=>void
}> = ({email,role,onCloseClicked}) => {

  const [toastPresent,toastDismiss] = useIonToast();

  const [state,setState] = useState<Json>({email:email,role:role});

  const [present, dismiss] = useIonLoading();

   

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>更新密码</IonTitle>
        </IonToolbar>
      </IonHeader>

      <>
      <IonContent fullscreen>
        <IonItem>
          <IonLabel position="floating">邮箱</IonLabel>
          <IonInput disabled={true} value={state.email} onIonChange={e => setState({...state,email: e.detail.value})}></IonInput>
        </IonItem>
       <IonItem>
          <IonLabel position="floating">原密码</IonLabel>
          <IonInput value={state.passwd} onIonChange={e => setState({...state,passwd: e.detail.value})} type='password'></IonInput>
        </IonItem>
        <IonItem>
          <IonLabel position="floating">新密码</IonLabel>
          <IonInput value={state.newpasswd} onIonChange={e => setState({...state,newpasswd: e.detail.value})} type='password'></IonInput>
        </IonItem>
        <IonItem>
          <IonLabel position="floating">重复新密码</IonLabel>
          <IonInput value={state.repasswd} onIonChange={e => setState({...state,repasswd: e.detail.value})} type='password'></IonInput>
        </IonItem>
      </IonContent>
      
      <IonItem className={styles.bottom_bar} lines="none">
          <IonButton slot="end"  size="default" color="secondary" expand="block" fill="solid" disabled={!state.email || !state.passwd}
            onClick={()=>{
              if (state.newpasswd.length < 8){
                toastPresent({
                  message: '新密码长度不得少于8位', 
                  duration: 3000,
                  color:'warning'
                });
                return;
              }
              if (state.repasswd !== state.newpasswd){
                // alert('新密码两次输入不一致');
                toastPresent({
                  message: '新密码两次输入不一致', 
                  duration: 3000,
                  color:'warning'
                });
                return;
              }


              present();

              updatePassword({email:state.email,passwd:state.passwd,newpass: state.newpasswd},d=>{

                dismiss();
                if (d.code == 200){

                  toastPresent({
                    message: "更新成功", 
                    duration: 3000,
                    color:'success'
                  });


                  onCloseClicked();
                }else{
                  toastPresent({
                    message: d.message, 
                    duration: 3000,
                    color:'warning'
                  });
                }
              });
           
          }} >确认</IonButton>
      </IonItem>
      </>

    </IonPage>
  );
};

export default UpdatePassword;
